import qs from 'qs'
import { get, post } from './request'

// pk模式成功的时候提交状态给证书判断用
export const submitPkStatus = (data, config) => {
  return post('/answer/pk_result', qs.stringify(data), config)
}

// 获取证书领取状态
export const getCertificateStatus = (data, config) => {
  return get('/question_active/certificate_info', data, config)
}

// 领取证书
export const getCertificate = (data, config) => {
  return post('/question_active/certificate_receive', qs.stringify(data), config)
}

// 查看证书详情
export const getCertificateDetail = (data, config) => {
  return get('/question_active/certificate_my', data, config)
}

// 是否弹领取证书
export const isPopCertificate = (data, config) => {
  return get('/question_active/certificate_status', data, config)
}
